
import { TranslationRecord } from '../../types';

export const privacyPolicy: TranslationRecord = {
  // Privacy Policy Page
  privacyPolicy: 'Privacy Policy',
  privacyPolicyDescription: 'Privacy Policy for Loena Luxury Suites in Thessaloniki, Greece. Learn how we collect, use, and protect your personal information.',
  loading: 'Loading...',
  loadingPrivacyPolicy: 'Loading privacy policy content...',
  enableJavaScript: 'Please enable JavaScript to view our Privacy Policy.',
  privacyPolicyLastUpdated: 'Last updated: May 2025',
  privacyPolicyContactText: 'If you have any questions about our privacy practices, please contact us at',
  
  // Google Analytics section
  analyticsTitle: 'Google Analytics',
  analyticsText: 'We use Google Analytics to collect information about how visitors use our website. The information we collect includes the pages visited, time spent on the website, and general location data. This information is processed in a way that does not directly identify anyone. We use this data to improve our website and services.',
  
  // Third-party data sharing section
  dataSharing: 'Data Sharing with Third Parties',
  dataSharingIntro: 'In order to provide our services and enhance your experience with us, Loena Luxury Suites may share certain personal data with trusted third-party service providers. These providers help us with various operational aspects of our business, including booking management, property access, and guest services.',
  dataSharingPurpose: 'We only share the minimum necessary information required for these services to function properly and to deliver the services you\'ve requested.',
  thirdPartyServices: 'Third-Party Service Providers',
  thirdPartyServicesIntro: 'The following are the main third-party services we use and may share your data with:',
  
  // Individual services
  webhotelierTitle: 'Webhotelier Channel Manager / Booking Engine',
  webhotelierDesc: 'Used to manage bookings and reservations. We may share your contact details, arrival and departure dates, and accommodation preferences.',
  
  hotelizerTitle: 'Hotelizer Property Management System (PMS)',
  hotelizerDesc: 'Used for property management and guest service coordination. We may share your booking details, contact information, and preferences to facilitate your stay.',
  
  tourmieTitle: 'Tourmie Guest Management App',
  tourmieDesc: 'Used to enhance guest experience and provide personalized services. We may share your contact details and stay information to facilitate communication and service delivery.',
  
  welcomePickupsTitle: 'Welcome Pickups',
  welcomePickupsDesc: 'Used for airport and other transportation services. If you request transfer services, we may share your arrival/departure details, contact information, and pickup/drop-off locations.',
  
  remoteLockTitle: 'Remote Lock & TTLock',
  remoteLockDesc: 'Used to provide secure access to our property. We may share your name, contact details, and duration of stay to generate and manage access codes for your accommodation.',
  
  dataProtection: 'Data Protection Measures',
  dataProtectionDesc: 'We ensure that all third-party service providers comply with applicable data protection laws and maintain appropriate security measures to protect your personal information. These providers are only permitted to use your data for the specific purposes outlined above and in accordance with our instructions.',
  
  moreInformation: 'For more information about how these third parties process your data, please refer to their respective privacy policies.',
};
